import React from "react"
import styled from "styled-components"
import { css } from "../styles/GlobalStyles"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 10px;
  overflow: hidden;
`

const Image = styled.img`
  width: 4rem;
  object-fit: cover;
  object-position: center center;
  border-radius: 50%;
  box-shadow: var(--shadow-elavated);

  @media (min-width: ${css.breakpoints.split}) {
    width: 265px;
  }
`

type Props = {
  url: string
}

const ProfilePic = ({url}: Props) => {
  return (
    <Container>
      <Image src={url} />
    </Container> 
  )
}

export default ProfilePic